import React from 'react';

export default function KayitOl() {
  return (
    <section className="py-5 kayit-page">
      <div className="container" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="row justify-content-center w-100">
          <div className="col-lg-8">
            <div className="card p-5 text-center" style={{ backgroundColor: 'rgba(34, 13, 28, 0.9)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '15px' }}>
              <h2 className="mb-4" style={{ color: '#db9e37' }}>Kayıtlarımız Tamamlanmıştır</h2>
              <p style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.8)' }}>
                Bir Zamanlar Konferans kayıtlarımız kapanmıştır. Göstermiş olduğunuz yoğun ilgi için teşekkür ederiz!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
